(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-bestsellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    console.log('[sy-bestsellers] init');
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-sy-bsl]').forEach(function (section) {
      if (section.dataset.syBslInit === '1') return;
      section.dataset.syBslInit = '1';
      if (prefersReduced || !('IntersectionObserver' in window)) return;
      section.classList.add('sy-bsl--anim');
      var items = section.querySelectorAll('[data-anim]');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var idx = Array.prototype.indexOf.call(items, el);
          el.style.transitionDelay = Math.min(idx, 6) * 60 + 'ms';
          el.classList.add('is-in');
          observer.unobserve(el);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
      items.forEach(function (el) { observer.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-brand-statement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    console.log('[sy-brand-statement] init');
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-sy-bs]').forEach(function (section) {
      if (section.dataset.syBsInit === '1') return;
      section.dataset.syBsInit = '1';
      if (prefersReduced || !('IntersectionObserver' in window)) return;
      section.classList.add('sy-bs--anim');
      var items = section.querySelectorAll('[data-anim]');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var idx = Array.prototype.indexOf.call(items, el);
          el.style.transitionDelay = Math.min(idx, 6) * 60 + 'ms';
          el.classList.add('is-in');
          observer.unobserve(el);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
      items.forEach(function (el) { observer.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-collection-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-sy-cfaq]');
  if (!root) return;
  console.log('[sy-collection-faq] init');
  var items = root.querySelectorAll('.sy-cfaq__item');
  items.forEach(function(it){
    it.addEventListener('toggle', function(){
      if (!it.open) return;
      items.forEach(function(other){ if (other !== it) other.open = false; });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    console.log('[sy-faq] init');
    var pr = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-sy-faq]').forEach(function (section) {
      if (section.dataset.syFaqInit === '1') return; section.dataset.syFaqInit = '1';
      var root = section.closest('[data-sy-root]') || section.parentNode;
      if (root && root.classList) root.classList.add('sy-faq--anim');

      var items = section.querySelectorAll('.sy-faq__item');
      // One open at a time
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });

      // Scroll-in reveal
      if (pr || !('IntersectionObserver' in window)) return;
      var anims = section.querySelectorAll('[data-anim]');
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) return; e.target.classList.add('is-in'); io.unobserve(e.target); }); }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
      anims.forEach(function (el) { io.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-featured-collections"] && !Shopify.designMode) return;
  try {
    
  /* ============================================================
     SY · Featured Collections — vanilla JS
     Scroll-in fade-up via IntersectionObserver. Content is visible by
     default; the animation class is added ONLY when JS runs and the user
     has not requested reduced motion — so there is never a hidden-content
     trap. Multi-instance safe.
     ============================================================ */
  (function () {
    console.log('[sy-featured-collections] init');

    var prefersReduced =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-sy-fc]').forEach(function (section) {
      if (section.dataset.syFcInit === '1') return;
      section.dataset.syFcInit = '1';

      /* ---- Category tab row: scroll-right arrow (shown only on overflow) ---- */
      var tabsRow = section.querySelector('.sy-fc__tabs');
      var tabsNext = section.querySelector('[data-sy-fc-tabs-next]');
      if (tabsRow && tabsNext) {
        var syncArrow = function () {
          var overflow = tabsRow.scrollWidth - tabsRow.clientWidth > 4;
          var atEnd = tabsRow.scrollLeft + tabsRow.clientWidth >= tabsRow.scrollWidth - 4;
          tabsNext.hidden = !overflow || atEnd;
        };
        tabsNext.addEventListener('click', function () {
          tabsRow.scrollBy({ left: Math.max(tabsRow.clientWidth * 0.7, 160), behavior: 'smooth' });
        });
        tabsRow.addEventListener('scroll', syncArrow, { passive: true });
        window.addEventListener('resize', syncArrow);
        syncArrow();
      }

      if (prefersReduced || !('IntersectionObserver' in window)) return;

      section.classList.add('sy-fc--anim');
      var items = section.querySelectorAll('[data-anim]');

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            var idx = Array.prototype.indexOf.call(items, el);
            el.style.transitionDelay = Math.min(idx, 6) * 70 + 'ms';
            el.classList.add('is-in');
            observer.unobserve(el);
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
      );

      items.forEach(function (el) { observer.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-header"] && !Shopify.designMode) return;
  try {
    
  /* ============================================================
     SY · Header — vanilla JS
     - Sticky scroll shadow
     - Mobile drawer open/close + focus trap + ESC + click outside
     - Optional predictive search via /search/suggest.json
     Multi-instance safe: each header roots its own listeners.
     ============================================================ */
  (function () {
    const roots = document.querySelectorAll('[data-sy-root]');
    if (!roots.length) return;

    roots.forEach(initHeader);

    function initHeader(root) {
      if (root.dataset.syInit === '1') return;
      root.dataset.syInit = '1';

      const header = root.querySelector('[data-sy-header]');
      const drawer = root.querySelector('[data-sy-drawer]');
      const drawerSearchInput = root.querySelector('[data-sy-drawer-search-input]');
      const openers = root.querySelectorAll('[data-sy-drawer-open]');
      const closers = root.querySelectorAll('[data-sy-drawer-close]');
      let lastFocus = null;

      /* ---------- Scroll-to-opaque ----------
         Header is transparent over the hero; flips to opaque cream after the
         user scrolls past a threshold (~80px gives the hero a moment of pure
         transparency before chrome appears). */
      if (header && header.dataset.sticky === 'true') {
        const onScroll = () => {
          if (window.scrollY > 80) header.classList.add('is-scrolled');
          else header.classList.remove('is-scrolled');
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      /* ---------- Drawer ---------- */
      function openDrawer(opener) {
        if (!drawer) return;
        lastFocus = opener || document.activeElement;
        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('sy-drawer-open');
        openers.forEach((b) => b.setAttribute('aria-expanded', 'true'));

        // If the opener was the mobile search toggle, focus the drawer search field
        if (opener && opener.hasAttribute('data-focus-search') && drawerSearchInput) {
          setTimeout(() => drawerSearchInput.focus(), 250);
        } else {
          // Otherwise, focus the first focusable element in the panel
          setTimeout(() => focusFirstIn(drawer), 50);
        }
      }

      function closeDrawer() {
        if (!drawer) return;
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('sy-drawer-open');
        openers.forEach((b) => b.setAttribute('aria-expanded', 'false'));
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }

      openers.forEach((btn) => btn.addEventListener('click', (e) => {
        e.preventDefault();
        openDrawer(btn);
      }));
      closers.forEach((btn) => btn.addEventListener('click', closeDrawer));

      // Close on link click inside drawer
      if (drawer) {
        drawer.addEventListener('click', (e) => {
          const link = e.target.closest('a[href]');
          if (link && drawer.contains(link)) closeDrawer();
        });
      }

      // ESC + focus trap
      document.addEventListener('keydown', (e) => {
        if (!drawer || drawer.getAttribute('aria-hidden') !== 'false') return;
        if (e.key === 'Escape') {
          e.preventDefault();
          closeDrawer();
          return;
        }
        if (e.key === 'Tab') {
          trapFocus(e, drawer);
        }
      });

      /* ---------- Predictive search ---------- */
      const searches = root.querySelectorAll('[data-sy-search]');
      searches.forEach((form) => {
        if (form.dataset.suggest !== 'true') return;
        const input = form.querySelector('.sy-header__search-input');
        const dropdown = form.querySelector('[data-sy-suggest]');
        if (!input || !dropdown) return;

        let debounce;
        let activeIndex = -1;

        input.addEventListener('input', () => {
          const q = input.value.trim();
          clearTimeout(debounce);
          if (q.length < 2) {
            hideDropdown();
            return;
          }
          debounce = setTimeout(() => fetchSuggestions(q), 220);
        });

        input.addEventListener('keydown', (e) => {
          const items = dropdown.querySelectorAll('.sy-suggest-item');
          if (!items.length) return;
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            activeIndex = (activeIndex + 1) % items.length;
            updateActive(items);
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            activeIndex = (activeIndex - 1 + items.length) % items.length;
            updateActive(items);
          } else if (e.key === 'Enter' && activeIndex >= 0) {
            e.preventDefault();
            items[activeIndex].click();
          } else if (e.key === 'Escape') {
            hideDropdown();
            input.blur();
          }
        });

        document.addEventListener('click', (e) => {
          if (!form.contains(e.target)) hideDropdown();
        });

        function updateActive(items) {
          items.forEach((it, i) => it.classList.toggle('is-active', i === activeIndex));
        }

        function hideDropdown() {
          dropdown.hidden = true;
          dropdown.innerHTML = '';
          activeIndex = -1;
        }

        async function fetchSuggestions(q) {
          try {
            const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                        '&resources[type]=product' +
                        '&resources[limit]=5' +
                        '&resources[options][unavailable_products]=last';
            const res = await fetch(url, { headers: { Accept: 'application/json' } });
            if (!res.ok) throw new Error('Search failed');
            const data = await res.json();
            renderResults(data.resources && data.resources.results && data.resources.results.products || []);
          } catch (err) {
            hideDropdown();
          }
        }

        function renderResults(products) {
          if (!products.length) {
            hideDropdown();
            return;
          }
          activeIndex = -1;
          dropdown.innerHTML = products.map((p) => {
            const img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
            const price = p.price ? formatMoney(p.price) : '';
            const title = escapeHTML(p.title || '');
            return (
              '<a class="sy-suggest-item" role="option" href="' + escapeAttr(p.url) + '">' +
                (img ? '<img class="sy-suggest-item__img" src="' + escapeAttr(img) + '" alt="" loading="lazy">' : '<span class="sy-suggest-item__img"></span>') +
                '<span class="sy-suggest-item__title">' + title + '</span>' +
                (price ? '<span class="sy-suggest-item__price">' + price + '</span>' : '') +
              '</a>'
            );
          }).join('');
          dropdown.hidden = false;
        }

        function formatMoney(value) {
          // Suggest API returns price as a string in shop currency (e.g. "$42.00") — pass through.
          return String(value);
        }
        function escapeHTML(s) {
          return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
        }
        function escapeAttr(s) { return escapeHTML(s); }
      });
    }

    /* ---------- Focus trap ---------- */
    function trapFocus(e, container) {
      const focusables = container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }

    function focusFirstIn(container) {
      const focusable = container.querySelector(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (focusable) focusable.focus();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-hero"] && !Shopify.designMode) return;
  try {
    
  /* ============================================================
     SY · Hero — vanilla JS
     - Video lightbox: open/close, ESC, backdrop, focus trap + restore
     - Builds YouTube/Vimeo embed for URL-based videos; pauses native
     (Entry animation is CSS-only — no JS.)
     Multi-instance safe.
     ============================================================ */
  (function () {
    const roots = document.querySelectorAll('[data-sy-root]');
    roots.forEach(initHero);

    function initHero(root) {
      const hero = root.querySelector('[data-sy-hero]');
      if (!hero || hero.dataset.syHeroInit === '1') return;
      hero.dataset.syHeroInit = '1';

      /* Entry animation is now CSS-only (see @keyframes sy-hero-rise) —
         no JS reveal, so content can never get stuck hidden. */

      /* ---------- Video lightbox ---------- */
      const lightbox = root.querySelector('[data-sy-hero-lightbox]');
      const opener = root.querySelector('[data-sy-hero-video-open]');
      if (!lightbox || !opener) return;

      const media = lightbox.querySelector('[data-sy-hero-video-media]');
      const closers = lightbox.querySelectorAll('[data-sy-hero-video-close]');
      const videoUrl = media ? media.getAttribute('data-video-url') : null;
      const nativeVideo = media ? media.querySelector('video') : null;
      let lastFocus = null;

      function openLightbox() {
        lastFocus = document.activeElement;
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.classList.add('sy-hero-lightbox-open');
        opener.setAttribute('aria-expanded', 'true');

        if (videoUrl && media && !media.querySelector('iframe')) {
          const iframe = document.createElement('iframe');
          iframe.src = toEmbed(videoUrl);
          iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('title', opener.getAttribute('aria-label') || 'Video');
          media.appendChild(iframe);
        } else if (nativeVideo) {
          try { nativeVideo.currentTime = 0; nativeVideo.play(); } catch (e) {}
        }

        const closeBtn = lightbox.querySelector('.sy-hero__lightbox-close');
        setTimeout(() => { if (closeBtn) closeBtn.focus(); }, 60);
      }

      function closeLightbox() {
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('sy-hero-lightbox-open');
        opener.setAttribute('aria-expanded', 'false');

        const iframe = media && media.querySelector('iframe');
        if (iframe) iframe.remove();
        if (nativeVideo) { try { nativeVideo.pause(); } catch (e) {} }

        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }

      opener.addEventListener('click', openLightbox);
      closers.forEach((b) => b.addEventListener('click', closeLightbox));

      document.addEventListener('keydown', (e) => {
        if (lightbox.getAttribute('aria-hidden') !== 'false') return;
        if (e.key === 'Escape') { e.preventDefault(); closeLightbox(); return; }
        if (e.key === 'Tab') trapFocus(e, lightbox);
      });

      function toEmbed(url) {
        let m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
        if (m) return 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1&rel=0&modestbranding=1';
        m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
        if (m) return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1';
        return url;
      }
    }

    function trapFocus(e, container) {
      const focusables = container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), iframe, video, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-journal-previews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    console.log('[sy-journal-previews] init');
    var pr = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-sy-jr]').forEach(function (section) {
      if (section.dataset.syJrInit === '1') return; section.dataset.syJrInit = '1';
      if (pr || !('IntersectionObserver' in window)) return;
      section.classList.add('sy-jr--anim');
      var items = section.querySelectorAll('[data-anim]');
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) return; var el = e.target; var i = Array.prototype.indexOf.call(items, el); el.style.transitionDelay = Math.min(i, 6) * 60 + 'ms'; el.classList.add('is-in'); io.unobserve(el); }); }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
      items.forEach(function (el) { io.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-lifestyle-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    console.log('[sy-lifestyle-band] init');
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-sy-lb]').forEach(function (section) {
      if (section.dataset.syLbInit === '1') return;
      section.dataset.syLbInit = '1';
      if (prefersReduced || !('IntersectionObserver' in window)) return;
      /* A page hero is above the fold on load. Fading it in means the first paint
         is an empty band, and an observer that has not fired yet is indistinguishable
         from a broken section. The journal hero does not animate either. */
      if (section.classList.contains('sy-lb--hero')) return;
      section.classList.add('sy-lb--anim');
      var items = section.querySelectorAll('[data-anim]');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
      items.forEach(function (el) { observer.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-material-compare"] && !Shopify.designMode) return;
  try {
    
  (function () {
    console.log('[sy-material-compare] init');
    // fitness: good = scores a point; avoid = hard exclude when that axis value is selected
    var FIT = {
      fiberglass: { good: { clim:['cold','hot','coastal'], loc:['rooftop','patio','commercial'], pri:['light','lowmaint','modern'] }, avoid:{} },
      fiberstone: { good: { clim:['cold','hot','mild'], loc:['patio'], pri:['natural'] }, avoid:{} },
      resin:      { good: { clim:['cold','hot','coastal'], loc:['rooftop','commercial','patio'], pri:['light','lowmaint','eco'] }, avoid:{} },
      corten:     { good: { clim:['cold'], loc:['patio','commercial'], pri:['lowmaint','modern','eco'] }, avoid:{ clim:['coastal'] } },
      aluminum:   { good: { clim:['cold','coastal','hot'], loc:['rooftop','commercial','patio'], pri:['light','lowmaint','modern','eco'] }, avoid:{} },
      caststone:  { good: { clim:['cold','hot','mild'], loc:['patio'], pri:['natural'] }, avoid:{} },
      concrete:   { good: { clim:['cold','hot'], loc:['patio'], pri:['natural','modern'] }, avoid:{ loc:['rooftop'] } },
      terracotta: { good: { clim:['hot','mild'], loc:['patio'], pri:['natural'] }, avoid:{ clim:['cold'] } },
      ceramic:    { good: { clim:['mild','hot'], loc:['patio'], pri:['natural'] }, avoid:{ clim:['cold'] } },
      wood:       { good: { clim:['cold','coastal','hot'], loc:['patio','rooftop'], pri:['natural','eco'] }, avoid:{} }
    };
    var LABEL = { fiberglass:'Fiberglass', fiberstone:'Fiberstone', resin:'HDPE Resin', corten:'Corten Steel', aluminum:'Aluminum', caststone:'Cast Stone / GFRC', concrete:'Concrete', terracotta:'Terracotta', ceramic:'Glazed Ceramic', wood:'Wood' };
    var WARN = {
      coastal: 'Skip Corten steel near salt air. Salt stops its protective patina from forming.',
      rooftop: 'Solid concrete and cast stone are usually too heavy for rooftops. Lighter materials are the safe call.',
      cold: 'Terracotta and basic ceramic crack in freeze-thaw. Choose non-porous or flexible materials and keep drainage clear.'
    };

    function init(section) {
      if (section.dataset.syMatInit === '1') return;
      section.dataset.syMatInit = '1';
      var opts  = section.querySelectorAll('[data-axis]');
      var cards = section.querySelectorAll('[data-mat]');
      var reco  = section.querySelector('[data-mat-reco]');
      var sel = { clim:null, loc:null, pri:null };

      function run() {
        var any = sel.clim || sel.loc || sel.pri;
        if (!any) {
          cards.forEach(function (c) { c.classList.remove('is-hl','is-dim'); });
          reco.hidden = true; reco.innerHTML = ''; return;
        }
        var scored = [];
        Object.keys(FIT).forEach(function (k) {
          var f = FIT[k], excluded = false, score = 0;
          ['clim','loc','pri'].forEach(function (ax) {
            var v = sel[ax]; if (!v) return;
            if ((f.avoid[ax] || []).indexOf(v) !== -1) excluded = true;
            if ((f.good[ax] || []).indexOf(v) !== -1) score++;
          });
          if (!excluded) scored.push({ k: k, score: score });
        });
        scored.sort(function (a, b) { return b.score - a.score; });
        var top = scored.filter(function (x) { return x.score > 0; }).slice(0, 4);
        if (top.length === 0) top = scored.slice(0, 3);   // fallback: best non-excluded
        var winners = top.map(function (x) { return x.k; });

        cards.forEach(function (c) {
          var on = winners.indexOf(c.dataset.mat) !== -1;
          c.classList.toggle('is-hl', on);
          c.classList.toggle('is-dim', !on);
        });

        var warns = [];
        ['cold','coastal','rooftop'].forEach(function (w) {
          if ((sel.clim === w || sel.loc === w) && WARN[w]) warns.push(WARN[w]);
        });
        reco.innerHTML =
          '<p class="sy-mat__reco-title">Best fits for your spot</p>' +
          '<p class="sy-mat__reco-mats">' + winners.map(function (k) { return LABEL[k]; }).join(' · ') + '</p>' +
          '<p class="sy-mat__reco-why">Highlighted below. All are a strong match for what you told us; pick by the look and weight that suit you.</p>' +
          warns.map(function (w) { return '<p class="sy-mat__reco-warn">' + w + '</p>'; }).join('');
        reco.hidden = false;
      }

      opts.forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () {
          var ax = b.dataset.axis, v = b.dataset.val;
          var turningOn = sel[ax] !== v;
          section.querySelectorAll('[data-axis="' + ax + '"]').forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-pressed', 'false'); });
          sel[ax] = turningOn ? v : null;
          if (turningOn) { b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true'); }
          run();
        });
      });

      var pr = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!pr && 'IntersectionObserver' in window) {
        section.classList.add('sy-mat--anim');
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
        section.querySelectorAll('[data-anim]').forEach(function (el) { io.observe(el); });
      }
    }
    document.querySelectorAll('[data-sy-mat]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    console.log('[sy-newsletter] init');
    var pr = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-sy-nl]').forEach(function (section) {
      if (section.dataset.syNlInit === '1') return; section.dataset.syNlInit = '1';
      if (pr || !('IntersectionObserver' in window)) return;
      section.classList.add('sy-nl--anim');
      var items = section.querySelectorAll('[data-anim]');
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) return; e.target.classList.add('is-in'); io.unobserve(e.target); }); }, { rootMargin: '0px 0px -10% 0px', threshold: 0.2 });
      items.forEach(function (el) { io.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-pdp-features"] && !Shopify.designMode) return;
  try {
    
(function(){
  var items = document.querySelectorAll('[data-sy-feat] .sy-feat__item');
  if (!items.length) return;
  console.log('[sy-pdp-features] init');
  if (!('IntersectionObserver' in window)) { items.forEach(function(i){ i.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold:.15 });
  items.forEach(function(i){ io.observe(i); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-pdp-finishes"] && !Shopify.designMode) return;
  try {
    
(function(){
  var band = document.querySelector('[data-sy-fin]');
  if (!band) return;
  console.log('[sy-pdp-finishes] init');

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: .15 });
    io.observe(band);
  } else {
    band.classList.add('is-in');
  }

  band.addEventListener('click', function(e){
    var tile = e.target.closest('[data-sy-fin-pick]');
    if (!tile) return;
    var want = tile.getAttribute('data-sy-fin-pick').toLowerCase();
    var picked = null;
    document.querySelectorAll('variant-picker input[type="radio"], .product-info input[type="radio"]').forEach(function(inp){
      if (!picked && (inp.value || '').toLowerCase() === want) picked = inp;
    });
    if (picked) {
      picked.click();
      var picker = picked.closest('variant-picker') || picked.closest('fieldset') || picked;
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      var buybox = document.querySelector('.product-info, [id^="shopify-section"] .product');
      if (buybox) buybox.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-pdp-lifestyle"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els = document.querySelectorAll('[data-sy-space]');
  if (!els.length) return;
  console.log('[sy-pdp-lifestyle] init');
  // reveal on scroll
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold:.12 });
    els.forEach(function(e){ io.observe(e); });
  } else {
    els.forEach(function(e){ e.classList.add('is-in'); });
  }
  // click-to-zoom lightbox (one per section)
  els.forEach(function(sec){
    var lb = sec.querySelector('[data-sy-lb]');
    if (!lb) return;
    var lbImg = lb.querySelector('.sy-space__lb-img');
    function open(src, alt){ lbImg.src = src; lbImg.alt = alt || ''; lb.hidden = false; lb.setAttribute('aria-hidden','false'); requestAnimationFrame(function(){ lb.classList.add('is-open'); }); document.documentElement.style.overflow='hidden'; }
    function close(){ lb.classList.remove('is-open'); document.documentElement.style.overflow=''; setTimeout(function(){ lb.hidden = true; lb.setAttribute('aria-hidden','true'); lbImg.src=''; lbImg.alt=''; }, 250); }
    sec.querySelectorAll('[data-sy-zoom]').forEach(function(btn){
      var im = btn.querySelector('img');
      btn.addEventListener('click', function(){ open(btn.getAttribute('data-sy-zoom'), im ? im.alt : ''); });
    });
    lb.addEventListener('click', function(e){ if (e.target === lb || e.target.closest('[data-sy-lb-close]')) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !lb.hidden) close(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-pdp-specs"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els = document.querySelectorAll('[data-sy-spec]');
  if (!els.length) return;
  console.log('[sy-pdp-specs] init');
  if (!('IntersectionObserver' in window)) { els.forEach(function(e){ e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold:.12 });
  els.forEach(function(e){ io.observe(e); });

  // Per-size highlight: only runs when a spec value has been authored with
  // <span class="sy-spec__sz" data-size="N"> markers (see spec_width etc.).
  // No-op on every other product — safe to ship globally.
  // Bail only when there is genuinely nothing to drive. This guard used to test
  // for '.sy-spec__sz' spans and '[data-sy-sz]' — both of which stopped existing
  // when Dimensions moved to size_table, so it returned early and the listener
  // never attached at all. Test for the things actually in use.
  var szSpans = document.querySelectorAll('[data-sy-spec] .sy-spec__sz');
  var sizeEl = document.querySelector('[data-sy-sizes]');
  if (!szSpans.length && !sizeEl) return;

  function highlight(sizeStr){
    var m = (sizeStr || '').match(/^(\d+(\.\d+)?)/);
    var n = m ? m[1] : null;
    szSpans.forEach(function(s){
      s.classList.toggle('sy-spec__sz--active', !!n && s.dataset.size === n);
    });
  }

  // The Size fieldset sits inside [data-dynamic-variant-content], which
  // variant-picker.js replaceWith()s on EVERY variant change. A listener bound
  // to that node dies after the first swap, and the highlight then freezes on
  // the previously selected size. So: hold no node references, listen on
  // document for the picker's own post-swap event, and re-read the option each
  // time. detail.selectedOptions is ordered by .option-selector, so find Size
  // by position rather than assuming it is first.
  function currentSize(detail){
    var selectors = document.querySelectorAll('variant-picker .option-selector');
    for (var i = 0; i < selectors.length; i++) {
      if (selectors[i].dataset.option !== 'Size') continue;
      if (detail && detail.selectedOptions) return detail.selectedOptions[i];
      var checked = selectors[i].querySelector('input.opt-btn:checked');
      return checked ? checked.value : null;
    }
    return null;
  }

  // Dimensions shows the selected size's own values. Server-rendered for the
  // initial variant, so this only has to keep up after a change.
  var sizeData = null;
  if (sizeEl) { try { sizeData = JSON.parse(sizeEl.textContent); } catch (e) { sizeData = null; } }

  function potWords(p){
    if (!p) return '';
    var m = p.match(/^([\d.]+)"?\s*\(x(\d+)\)$/);
    var w = ['','One','Two','Three','Four','Five','Six','Seven','Eight','Nine','Ten','Eleven','Twelve'];
    if (m) return (w[+m[2]] || m[2]) + ' ' + m[1] + ' in pots';
    return p.replace(/"/g, '').trim() + ' in pot';
  }

  function showSize(sizeLabel, sku){
    if (!sizeData) return;
    var r = sizeData.filter(function(x){ return x.size_label === sizeLabel; })[0]
         || sizeData.filter(function(x){ return x.sku === sku; })[0];
    if (!r) return;
    var ext = r.ext_disp + (r.rim_disp ? ' \u00b7 ' + r.rim_disp : '');
    // ⛔ ALL THREE INTERIOR KEYS, because `data-sz-field` is handleized from the label
    // the SERVER rendered for the FIRST size, and the label can differ between sizes of
    // one product. Cosapots Mondo Round is 'interior' on its four small sizes and
    // 'opening' on its four large ones, so the field is 'inside-dimensions' on load. With
    // only 'inside-opening' in this map the lookup missed, the value was left untouched,
    // and selecting the 42 in size still showed the 8.5 in size's "7.3 in x 4.2 in".
    var intKeys = { 'inside-opening': 1, 'inside-dimensions': 1, 'plantable-depth': 1 };
    var map = {
      'exterior': ext, 'diameter-height': ext,
      'inside-opening': r.int_disp || '',
      'inside-dimensions': r.int_disp || '',
      'plantable-depth': r.int_disp || '',
      'fits-grow-pot': potWords(r.grow_pot),
      'weight': r.weight_lb ? r.weight_lb + ' lb' + (r.weight_basis === 'packed' ? ' (packed)' : '') : ''
    };
    // The LABEL is the claim, not decoration: an opening diameter printed under "Inside
    // dimensions" is exactly the spec_depth error, a real sourced number describing a
    // different quantity from the one the row names. So the label moves with the value.
    var intLabel = r.int_kind === 'plantable' ? 'Plantable depth'
                 : r.int_kind === 'interior'  ? 'Inside dimensions'
                 : 'Inside opening';
    document.querySelectorAll('[data-sz-field]').forEach(function(dd){
      var key = dd.dataset.szField;
      var v = map[key];
      if (v !== undefined && v !== '') dd.textContent = v;
      if (intKeys[key]) {
        var row = dd.closest('.sy-spec__row');
        var dt = row && row.querySelector('.sy-spec__k');
        if (dt) dt.textContent = intLabel;
      }
    });

    // Per-SIZE dimension drawing. Only Cosapots rows carry sheet_img, and only those
    // pages emit [data-sz-sheet-img], so this is a no-op on every Jay Scotts product:
    // their figure is one drawing for the whole series and must not move.
    var fig = document.querySelector('[data-sz-sheet-img]');
    if (fig) {
      var box = fig.closest('.sy-spec__sheet');
      if (r.sheet_img) {
        // separator, not a fixed '&' -- the stored urls have had ?v= stripped, and
        // '...png&width=1400' 404s on Shopify's CDN, which shows the alt text instead.
        var sep = r.sheet_img.indexOf('?') >= 0 ? '&' : '?';
        fig.src = r.sheet_img + sep + 'width=1400';
        fig.alt = (fig.getAttribute('data-sz-alt-base') || '') +
                  ' dimension drawing for the ' + r.size_label +
                  ' size: top, body and bottom views with measurement callouts';
        var lnk = fig.closest('a');
        if (lnk) lnk.href = r.sheet_full || r.sheet_img;
        if (box) { box.style.display = ''; box.classList.remove('sy-spec__sheet--empty'); }
      } else if (box) {
        // Reglito Cube's smallest size has no drawing (NewPro publish REIC.60 upward,
        // no REIC.50). Showing the previous size's drawing there would print dimensions
        // that contradict the size label above it, as pixels, where no sweep can read
        // them. Hide rather than mislead.
        box.style.display = 'none';
        box.classList.add('sy-spec__sheet--empty');
      }
      var ft = document.querySelector('[data-sz-figtitle]');
      if (ft && r.sheet_img) ft.textContent = r.sku + ' \u00b7 ' + r.size_label;
    }
  }

  highlight(currentSize());
  // Bound to document, reading only from event detail. Nothing here holds a node
  // inside the variant picker: it replaces those nodes wholesale on every change
  // via the Section Rendering API, which killed an earlier listener outright.
  document.addEventListener('on:variant:change', function(e){
    var d = e.detail || {};
    var label = currentSize(d);
    highlight(label);
    showSize(label, d.variant && d.variant.sku);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-sms-consent"] && !Shopify.designMode) return;
  try {
    
  console.log('[sy-sms-consent] init');
  (function () {
    var box = document.getElementById('sy-sms-optin');
    var phone = document.getElementById('sy-sms-phone');
    if (!box || !phone) return;
    var sync = function () {
      phone.required = box.checked;
      phone.setAttribute('aria-required', box.checked ? 'true' : 'false');
    };
    box.addEventListener('change', sync);
    sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-tools-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    console.log('[sy-tools-band] init');
    document.querySelectorAll('[data-sy-tb]').forEach(function (section) {
      if (section.dataset.syTbInit === '1') return;
      section.dataset.syTbInit = '1';
      var pr = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (pr || !('IntersectionObserver' in window)) return;
      section.classList.add('sy-tb--anim');
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
      section.querySelectorAll('[data-anim]').forEach(function (el) { io.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-trade-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    console.log('[sy-trade-cta] init');
    var pr = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-sy-tr]').forEach(function (section) {
      if (section.dataset.syTrInit === '1') return; section.dataset.syTrInit = '1';
      if (pr || !('IntersectionObserver' in window)) return;
      section.classList.add('sy-tr--anim');
      var items = section.querySelectorAll('[data-anim]');
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) return; e.target.classList.add('is-in'); io.unobserve(e.target); }); }, { rootMargin: '0px 0px -10% 0px', threshold: 0.2 });
      items.forEach(function (el) { io.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sy-trust-grid"] && !Shopify.designMode) return;
  try {
    
(function(){
  var sections = document.querySelectorAll('.sy-tg');
  if (!sections.length) return;
  console.log('[sy-trust-grid] init');
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  sections.forEach(function(sec){
    sec.classList.add('sy-tg--pre');
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { sec.classList.remove('sy-tg--pre'); io.disconnect(); }
      });
    }, { threshold: 0.12 });
    io.observe(sec);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
